import { render, staticRenderFns } from "./Short_form_tea_JumpAttribute.vue?vue&type=template&id=d394be96&scoped=true&"
import script from "./Short_form_tea_JumpAttribute.vue?vue&type=script&lang=js&"
export * from "./Short_form_tea_JumpAttribute.vue?vue&type=script&lang=js&"
import style0 from "./Short_form_tea_JumpAttribute.vue?vue&type=style&index=0&id=d394be96&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d394be96",
  null
  
)

export default component.exports